<template>
  <div class="company-employees-form">
    <div class="field">
      <label class="label">שם פרטי</label>
      <div class="control">
        <input
          v-model="formData.user.first_name"
          class="input"
          type="text"
          placeholder="שם פרטי"
          :class="{ 'is-danger': errors.first_name }"
        >
      </div>
      <p v-if="errors.first_name" class="help is-danger">{{ errors.first_name }}</p>
    </div>

    <div class="field">
      <label class="label">שם משפחה</label>
      <div class="control">
        <input
          v-model="formData.user.last_name"
          class="input"
          type="text"
          placeholder="שם משפחה"
          :class="{ 'is-danger': errors.last_name }"
        >
      </div>
      <p v-if="errors.last_name" class="help is-danger">{{ errors.last_name }}</p>
    </div>

    <div class="field">
      <label class="label">אימייל</label>
      <div class="control">
        <input
          v-model="formData.user.email"
          class="input"
          type="email"
          placeholder="אימייל"
          :class="{ 'is-danger': errors.email }"
        >
      </div>
      <p v-if="errors.email" class="help is-danger">{{ errors.email }}</p>
    </div>

    <div class="field">
      <label class="label">טלפון</label>
      <div class="control">
        <input
          v-model="formData.user.phone_number"
          class="input"
          type="tel"
          placeholder="טלפון"
        >
      </div>
    </div>

    <div class="field">
      <label class="label">תפקיד</label>
      <div class="control">
        <input
          v-model="formData.title"
          class="input"
          type="text"
          placeholder="תפקיד"
        >
      </div>
    </div>

    <div class="field">
      <label class="label">סטטוס</label>
      <div class="control">
        <div class="select">
          <select v-model="formData.user.status">
            <option value="pending">pending</option>
            <option value="active">active</option>
            <option value="blocked">blocked</option>
            <option value="expired">expired</option>
            <option value="test">test</option>
            <option value="currently_irrelevant">currently_irrelevant</option>
            <option value="pending_admin_approval">pending_admin_approval</option>
          </select>
        </div>
      </div>
    </div>

    <div v-if="!isEditing" class="field">
      <label class="label">סיסמא</label>
      <div class="control">
        <input
          v-model="formData.user.password"
          class="input"
          type="password"
          placeholder="סיסמא"
          :class="{ 'is-danger': errors.password }"
        >
      </div>
      <p v-if="errors.password" class="help is-danger">{{ errors.password }}</p>
    </div>

    <div class="field is-grouped">
      <div class="control">
        <button
          @click="saveEmployee"
          class="button is-success"
          :class="{ 'is-loading': saving }"
          :disabled="saving"
        >
          שמור
        </button>
      </div>
      <div class="control">
        <button @click="closeModal" class="button">ביטול</button>
      </div>
    </div>
  </div>
</template>

<script>
import Validator from '@/custom/classes/validator.js'

export default {
  name: 'CompanyEmployeesForm',
  props: ['payload'],
  data () {
    return {
      validator: new Validator(),
      saving: false,
      errors: {},
      formData: this.getEmptyEmployee()
    }
  },
  computed: {
    isEditing () {
      return this.payload.employee && this.payload.employee.id
    }
  },
  created () {
    this.initializeForm()
  },
  methods: {
    getEmptyEmployee () {
      return {
        id: null,
        title: '',
        user: {
          id: null,
          first_name: '',
          last_name: '',
          email: '',
          phone_number: '',
          status: 'active',
          password: ''
        }
      }
    },

    initializeForm () {
      if (this.payload.employee) {
        // Editing existing employee
        this.formData = {
          id: this.payload.employee.id,
          title: this.payload.employee.title || '',
          user: {
            id: this.payload.employee.user.id,
            first_name: this.payload.employee.user.first_name || '',
            last_name: this.payload.employee.user.last_name || '',
            email: this.payload.employee.user.email || '',
            phone_number: this.payload.employee.user.phone_number || '',
            status: this.payload.employee.user.status || 'active',
            password: ''
          }
        }
      } else {
        // Creating new employee
        this.formData = this.getEmptyEmployee()
      }
    },

    validateEmployee () {
      this.errors = {}
      let isValid = true

      if (!this.formData.user.first_name || !this.formData.user.first_name.trim()) {
        this.errors.first_name = 'שם פרטי חובה'
        isValid = false
      }

      if (!this.formData.user.last_name || !this.formData.user.last_name.trim()) {
        this.errors.last_name = 'שם משפחה חובה'
        isValid = false
      }

      if (!this.formData.user.email || !this.formData.user.email.trim()) {
        this.errors.email = 'אימייל חובה'
        isValid = false
      } else if (!this.validator.validateEmail({ value: this.formData.user.email })) {
        this.errors.email = 'אימייל לא תקין'
        isValid = false
      }

      if (!this.isEditing && (!this.formData.user.password || !this.formData.user.password.trim())) {
        this.errors.password = 'סיסמא חובה עבור עובד חדש'
        isValid = false
      }

      return isValid
    },

    async saveEmployee () {
      if (!this.validateEmployee()) {
        return
      }

      this.saving = true
      try {
        const employeeData = {
          company_id: this.payload.company_id,
          title: this.formData.title,
          user_attributes: {
            first_name: this.formData.user.first_name,
            last_name: this.formData.user.last_name,
            email: this.formData.user.email,
            phone_number: this.formData.user.phone_number,
            status: this.formData.user.status
          }
        }

        if (!this.isEditing) {
          // Creating new employee
          employeeData.user_attributes.password = this.formData.user.password
          await this.$network_utils.caller.request('post', '/company_employees/', 'admin_headers', {
            company_employee: employeeData
          })
          this.$utils.emit('show_toast', { text: 'עובד נוסף בהצלחה' })
        } else {
          // Updating existing employee
          await this.$network_utils.updateCompanyEmployee({
            id: this.formData.id,
            company_employee: employeeData
          })
          this.$utils.emit('show_toast', { text: 'עובד עודכן בהצלחה' })
        }

        // Call the onSave callback if provided
        if (this.payload.onSave && typeof this.payload.onSave === 'function') {
          this.payload.onSave()
        }

        this.closeModal()
      } catch (error) {
        console.error('Error saving employee:', error)
        this.$utils.emit('show_toast', { text: 'שגיאה בשמירת עובד' })
      } finally {
        this.saving = false
      }
    },

    closeModal () {
      this.$store.commit('modals/destroy', this.payload.designator)
    }
  }
}
</script>

<style scoped>
.company-employees-form {
  padding: 1rem;
}

.field:not(:last-child) {
  margin-bottom: 1rem;
}

.is-grouped {
  margin-top: 1.5rem;
}
</style>
